<template>
    <div class="fill-height of-y d-flex">
        <div class="fill-height d-flex align-center justify-center flex-grow-1" v-if="startingUp">
            <loader :size="52"></loader>
        </div>

        <template v-else>
            <div class="fill-height flex-grow-1" style="max-width: 350px; min-width: 350px">
                <v-scroll-x-transition hide-on-leave>
                    <multi-select-list
                            v-if="selectedGroup && showContracts "
                            :items="recruitmentContracts"
                            itemKey="id"
                            :showCheckBoxes="true"
                            :multiple="false"
                            headlineKey="description"
                            sub-line-key="description"
                            v-model="selectedContract"
                            filterLabel="Filter Contracts"
                            :return-object="true"
                    >
                        <div slot="header" class="px-2 pt-2">

                            <div class="d-flex align-center ">
                                <v-btn
                                        icon
                                        color="secondary"
                                        class="mr-3"
                                        @click="showContracts = false"
                                >
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                                <span class="text-h5">Contracts</span>
                            </div>

                            <v-btn
                                    small
                                    block
                                    color="primary"
                                    @click="showCreateContract = true"
                                    class="my-2"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Create Contract Group
                            </v-btn>
                        </div>

<!--                        <template v-slot:subLine="{value, index, selected}">-->
<!--                            &lt;!&ndash;                        <div class="d-flex align-center justify-space-between grey&#45;&#45;text" :class="value.disabled ? null : 'text&#45;&#45;darken-2'">&ndash;&gt;-->
<!--                            &lt;!&ndash;                            &ndash;&gt;-->
<!--                            &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                            Cut Off: {{format(value.cutOff, dateFormats.longDate)}}-->
<!--                        </template>-->

                        <template v-slot:action="{value, selected}">

                            <div class="d-flex align-center">
                                <v-tooltip left v-if="selected">
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                small
                                                icon
                                                color="primary"
                                                @click="modifyExistingContract(value)"
                                                class="mr-2"
                                                v-on="on"
                                        >
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    Edit Group Contract
                                </v-tooltip>

                                <v-avatar
                                        :color="randomMC.getColor({text: value.description})"
                                        :size="28"
                                        class="white--text mr-2"
                                >
                                    {{value.description.charAt(0)}}
                                </v-avatar>
                            </div>
                        </template>

                    </multi-select-list>
                </v-scroll-x-transition>

                <v-scroll-x-transition hide-on-leave>
                    <multi-select-list
                            v-if="!(selectedGroup && showContracts) && !refreshSelectList"
                            :items="archivedGroupFilter"
                            itemKey="id"
                            :showCheckBoxes="true"
                            :multiple="false"
                            headlineKey="description"
                            sub-line-key="cutOff"
                            v-model="selectedGroup"
                            filterLabel="Filter Groups"
                            :return-object="true"
                    >
                        <div slot="header" class="px-2 pt-2">
                            <v-btn
                                    small
                                    block
                                    color="primary"
                                    @click="showCreate = true"
                                    class="mb-2"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Create Recruitment Group
                            </v-btn>

                            <v-btn
                                    small
                                    block
                                    color="primary"
                                    @click="showSearchAll = true"
                                    class="mb-2"
                                    :outlined="true"
                            >
                                <v-icon left>mdi-magnify</v-icon>
                                Search All Recruitments
                            </v-btn>
                          
                          <v-btn
                              v-if="user.adminOptions.recruitmentArchived"
                              small
                              block
                              color="primary"
                              @click="archiveView = !archiveView"
                              class="mb-2"
                              :outlined="!archiveView"
                          >
                            <v-icon left>mdi-archive</v-icon>
                            {{ !archiveView ? 'Show' : 'Hide' }} Archived recruitments
                          </v-btn>
<!--                          TODO archive-->
                        </div>

                        <template v-slot:subLine="{value, index, selected}">
                            Cut Off: {{format(value.cutOff, dateFormats.longDate)}}
                        </template>

                        <template v-slot:action="{value, selected}">
                            <v-tooltip left v-if="selected">
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            small
                                            icon
                                            color="primary"
                                            @click="showModifyGroup = true"
                                            class="mr-2"
                                            v-on="on"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                Edit Recruitment Group
                            </v-tooltip>
                        </template>
                    </multi-select-list>
                </v-scroll-x-transition>
            </div>
            <div class="fill-height pl-1">
                <v-divider vertical></v-divider>
            </div>
            <div class="flex-grow-1 fill-height of-y">

                <div class="d-flex align-center justify-center fill-height" v-if="loadingRecruitmentDetail">
                    <loader :size="52"/>
                </div>
                <template v-else-if="selectedGroup != null">

                    <div class="fill-height of-y d-flex flex-column white">
                        <div class="d-flex justify-space-between align-center">
                            <div class="text-h6 pa-2">
                                {{selectedGroup.description}}{{selectedContract ? ` - ${selectedContract.description}` : null}}
                            </div>

                            <v-switch
                                    label="Unprocessed Only"
                                    v-model="processedFilter"
                                    hide-details
                                    class="pa-0 ma-0"
                            >

                            </v-switch>

                            <v-btn v-if="user.adminOptions.recruitmentExport || user.adminOptions.setup" @click="excelExport()" color="primary" text small><v-icon left>mdi-microsoft-excel</v-icon>Export To Excel</v-btn>
                            <v-btn v-if="user.adminOptions.recruitmentExport || user.adminOptions.setup" :disabled="loadingExclude" :loading="loadingExclude" @click="excelExc(true)" color="green" text small><v-icon left>mdi-microsoft-excel</v-icon>Inc</v-btn>
                            <v-btn v-if="user.adminOptions.recruitmentExport || user.adminOptions.setup" :disabled="loadingExclude" :loading="loadingExclude" @click="excelExc(false)" color="error" text small><v-icon left>mdi-microsoft-excel</v-icon>Exc</v-btn>

                            <div class="d-flex align-center">
                                <v-text-field
                                        v-model="searchStr"
                                        prepend-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        class="px-2 pt-0 mt-0"
                                        style="width: 300px; max-width: 300px"
                                ></v-text-field>
                                <v-menu
                                        bottom
                                        offset-y
                                >
                                    <template #activator="{on}">
                                        <v-btn
                                                v-on="on"
                                                color="primary"
                                                icon
                                                class="mx-2"
                                                :disabled="!selectedRecruitments.length"
                                        >
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-list dense>
                                            <v-list-item @click="showMoveToAnotherRecruitmentGroup = true">
                                                <v-list-item-avatar class="py-0 my-0">
                                                    <v-icon>mdi-account-group</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>Move to another recruitment group</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item @click="showMoveToContract = true">
                                                <v-list-item-avatar class="py-0 my-0">
                                                    <v-icon>mdi-file-sign</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>Move to group contract</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item @click="showDownloadRecruitmentApplications = true">
                                                <v-list-item-avatar class="py-0 my-0">
                                                    <v-icon>mdi-account-arrow-down</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>Download recruitment applications</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-menu>
                            </div>

                        </div>
                        <div class="flex-grow-1 of-y">
                            <v-data-table
                                    v-if="!refresh"
                                    :search="searchStr"
                                    dense
                                    fixed-header
                                    height="100%"
                                    class="fill-height of-y"
                                    hide-default-footer
                                    :headers="headers"
                                    :items="filteredDetail"
                                    :options="{itemsPerPage: filteredDetail.length}"
                                    sort-by="captured"
                                    :sort-desc="true"
                                    @click:row="modifyRecruitment"
                                    ref="recruitmentsTable"
                                    show-select
                                    selectable-key="id"
                                    v-model="selectedRecruitments"
                            >
                                <template v-slot:item.contract="{item}">
                                    <v-chip
                                            v-if="!item.fkRecruitmentContract"
                                            x-small
                                    >
                                        No Contract
                                    </v-chip>
                                    <v-chip
                                            v-else
                                            x-small
                                            :color="randomMC.getColor({text: recruitmentGroupContractsRef[item.fkRecruitmentContract].description})"
                                            class="white--text"
                                    >
                                        {{recruitmentGroupContractsRef[item.fkRecruitmentContract].description}}
                                    </v-chip>
                                </template>
                              <template v-slot:item.export="{item}">
                                <v-icon small :color="item.export ? 'green' : 'error'" >mdi-microsoft-excel</v-icon>
                              </template>
                                <template v-slot:item.captured="{item}">
                                    <span v-text="format(new Date(item.captured), 'yy-MM-dd HH:mm')" style="white-space: nowrap"/>
                                </template>
                                <template v-slot:item.clockNo="{item}">
                                    <template v-if="item.name && (item.idNo || item.passportNumber)">
                                        {{ item.clockNo }}
                                    </template>
                                    <template v-else>
                                        <v-btn
                                                small
                                                text
                                                color="amber darken-1"
                                        >Unprocessed</v-btn>
                                    </template>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </template>
            </div>

            <v-dialog
                    v-if="showModifyGroup || showCreate"
                    :value="showModifyGroup || showCreate"
                    :width="400"
                    persistent
            >
                <v-card class="of-y d-flex flex-column">

                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                        <div class="sub--text flex-grow-1">
                            {{showCreate ? 'Create Recruitment Group' : 'Modify Recruitment Group'}}
                        </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="showModifyGroup ? showModifyGroup = false : showCreate = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <divider color="primary darken-1"/>
                    <div class="flex-grow-1">
                        <modify-recruitment-group :group="showModifyGroup ? selectedGroup : createGroup" @input="groupChanged(showCreate, $event)"/>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog
                    v-if=showRecruitmentModify
                    v-model="showRecruitmentModify"
                    fullscreen
                    persistent
            >
                <v-card class="fill-height d-flex flex-column">
                    <div class="d-flex primary white--text align-center">
                        <v-card-title class="py-1 my-1">
                            Modify Recruitment
                        </v-card-title>

                        <div class="flex-grow-1 text-center">

                            <v-btn
                                    class="mx-4"
                                    icon
                                    color="white"
                                    :disabled="$refs.recruitmentsTable.selectableItems.indexOf(selectedRecruitment) === 0"
                                    @click="previousRecruitment"
                            >
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>

                            {{$refs.recruitmentsTable.selectableItems.indexOf(selectedRecruitment) + 1}} of {{$refs.recruitmentsTable.selectableItems.length}}

                            <v-btn
                                    class="mx-4"
                                    icon
                                    color="white"
                                    :disabled="$refs.recruitmentsTable.selectableItems.indexOf(selectedRecruitment) + 1 === $refs.recruitmentsTable.selectableItems.length"
                                    @click="nextRecruitment"
                            >
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>

                        <v-menu
                                bottom
                                offset-y
                        >
                            <template #activator="{on}">
                                <v-btn
                                        text
                                        color="white"
                                        v-on="on"
                                >
                                    Info
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>Recruitment Info</v-card-title>
                                <v-card-text>
                                    <div class="d-flex align-center py-1">
                                        <div class="flex-grow-1 flex-equal pr-2">Captured:</div>
                                        <div class="flex-grow-1 flex-equal font-weight-bold pl-2" style="white-space: nowrap">{{ selectedRecruitmentInfo.capturedStr }}</div>
                                    </div>

                                    <div class="d-flex align-center py-1">
                                        <div class="flex-grow-1 flex-equal pr-2">Captured By:</div>
                                        <div class="flex-grow-1 flex-equal font-weight-bold pl-2" style="white-space: nowrap">{{ selectedRecruitmentInfo.capturedBy }}</div>
                                    </div>


                                    <div class="d-flex align-center py-1">
                                        <div class="flex-grow-1 flex-equal pr-2">Synced From Device:</div>
                                        <div class="flex-grow-1 flex-equal font-weight-bold pl-2" style="white-space: nowrap">{{ selectedRecruitmentInfo.createdStr }}</div>
                                    </div>

                                    <div class="d-flex align-center py-1">
                                        <div class="flex-grow-1 flex-equal pr-2">Last Edited:</div>
                                        <div class="flex-grow-1 flex-equal font-weight-bold pl-2" style="white-space: nowrap">{{ selectedRecruitmentInfo.lastUpdatedBy }}</div>
                                    </div>

                                    <div class="d-flex align-center py-1">
                                        <div class="flex-grow-1 flex-equal pr-2">Last Edited By:</div>
                                        <div class="flex-grow-1 flex-equal font-weight-bold pl-2" style="white-space: nowrap">{{ selectedRecruitmentInfo.updatedStr }}</div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-menu>

                        <v-btn
                                text
                                color="white"
                                @click="showDownload = true"
                        >
                            Download Images
                        </v-btn>

                        <v-btn
                                text
                                color="white"
                                @click="showExcluded = true"
                        >
                            Excluded Words
                        </v-btn>


                        <v-btn
                                icon
                                color="white"
                                @click="showRecruitmentModify = false"
                                class="mx-2"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <modify-recruitment-dlg
                            v-if="selectedRecruitment"
                            :shown.sync="showRecruitmentModify"
                            :recruitment="selectedRecruitment"
                            @input="recruitmentUpdated"
                            ref="recruitmentDlg"
                            :show-download.sync="showDownload"
                    ></modify-recruitment-dlg>

                </v-card>
            </v-dialog>

            <v-dialog
                    v-if="showCreateContract || showModifyContract"
                    :value="showCreateContract || showModifyContract"
                    :width="400"
                    persistent
            >
                <v-card class="of-y d-flex flex-column">

                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                        <div class="sub--text flex-grow-1">
                            {{showCreate ? 'Create Contract Group' : 'Modify Contract Group'}}
                        </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="showCreateContract ? showCreateContract = false : showModifyContract = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <divider color="primary darken-1"/>

                    <v-card-text>
                        <v-form ref="modifyContractForm" @submit="$event.preventDefault()">
                            <v-text-field
                                    label="Contract Group Name"
                                    v-model="modifyContract.description"
                                    :rules="[validationRules.required, validationRules.notNull]"
                                    ref="contractGroupName"
                                    class="mt-2"
                                    hide-details="auto"
                            />
                            <v-autocomplete
                                    label="Recruitment Group"
                                    v-model="modifyContract.fkRecruitmentGroup"
                                    :rules="[validationRules.required]"
                                    :items="groups"
                                    item-text="description"
                                    item-value="id"
                                    hide-details="auto"
                                    :readonly="showModifyContract"
                                    :disabled="showModifyContract"
                            />
                            <v-autocomplete
                                    label="Contract"
                                    v-model="modifyContract.fkContract"
                                    :rules="[validationRules.required]"
                                    :items="contracts"
                                    item-text="description"
                                    item-value="id"
                                    hide-details="auto"
                            />
                        </v-form>

                    </v-card-text>
                    <div class="text-right pr-2 pb-1 pt-2">
                        <v-btn
                                @click="showCreateContract = false; showModifyContract = null"
                                color="primary"
                                :disabled="loadingModifyContract"
                                small
                                outlined
                                class="mr-2"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                                @click="validateModifyContract()"
                                color="primary"
                                :loading="loadingModifyContract"
                                :disabled="loadingModifyContract"
                                small
                        >
                            Save Changes
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>


            <v-dialog
                    v-if="showMoveToContract === true"
                    :value="showMoveToContract"
                    :width="400"
                    persistent
            >
                <v-card class="of-y d-flex flex-column">

                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                        <div class="sub--text flex-grow-1">
                            Move To Contract
                        </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="showMoveToContract = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <divider color="primary darken-1"/>

                    <v-list
                            dense
                            style="max-height: 300px" class="of-y"
                    >
                        <v-list-item-group
                                v-model="selectedMoveContract"
                                mandatory
                                color="primary"
                        >
                            <template v-for="contract in sortedContracts">
                                <v-list-item
                                        :key="contract.id"
                                        :value="contract.id"
                                >
                                    <v-list-item-avatar class="my-0 py-0">
                                        <v-avatar :size="28" :color="randomMC.getColor({text: contract.description})" class="white--text">
                                            {{contract.description.charAt(0)}}
                                        </v-avatar>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="contract.description"/>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-item-group>
                    </v-list>

                    <v-divider></v-divider>

                    <div class="text-right pr-2 pb-1 pt-2">
                        <v-btn
                                @click="showMoveToContract = false"
                                color="primary"
                                :disabled="loadingMoveToContract"
                                small
                                outlined
                                class="mr-2"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                                @click="moveToContract"
                                color="primary"
                                :loading="loadingMoveToContract "
                                :disabled="loadingMoveToContract || !selectedMoveContract"
                                small
                        >
                            Move To Group Contract
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <v-dialog
                    v-if="showMoveToAnotherRecruitmentGroup === true"
                    :value="showMoveToAnotherRecruitmentGroup"
                    :width="400"
                    persistent
            >
                <v-card class="of-y d-flex flex-column">

                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">
                        <div class="sub--text flex-grow-1">
                            Move To Recruitment Group
                        </div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="showMoveToAnotherRecruitmentGroup = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <divider color="primary darken-1"/>

                    <div class="text-overline error--text text-center pa-3" style="line-height: normal">
                        *Please note that this action, will remove all the selected recruitments from any linked group contracts
                    </div>
                    <v-divider/>
                  
                  <v-text-field
                      solo
                      prepend-icon="mdi-magnify"
                      label="Search"
                      hide-details="auto"
                      class="mx-3"
                      v-model="moveFilter"
                  >
                  
                  </v-text-field>

                    <v-list
                            dense
                            style="max-height: 300px" class="of-y"
                    >
                        <v-list-item-group
                                v-model="selectedMoveToAnotherRecruitmentGroup"
                                mandatory
                                color="primary"
                        >
                            <template v-for="group in moveGroups">
                                <v-list-item
                                        :key="group.id"
                                        :value="group.id"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title v-text="group.description"/>
                                        <v-list-item-subtitle v-text="`Cut Off: ${format(group.cutOff, dateFormats.longDate)}`"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-item-group>
                    </v-list>

                    <v-divider></v-divider>

                    <div class="text-right pr-2 pb-1 pt-2">
                        <v-btn
                                @click="showMoveToAnotherRecruitmentGroup = false"
                                color="primary"
                                :disabled="loadingMoveToAnotherRecruitmentGroup"
                                small
                                outlined
                                class="mr-2"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                                @click="moveToRecruitment"
                                color="primary"
                                :loading="loadingMoveToAnotherRecruitmentGroup "
                                :disabled="loadingMoveToAnotherRecruitmentGroup || !selectedMoveToAnotherRecruitmentGroup"
                                small
                        >
                            Move To Recruitment Group
                        </v-btn>
                    </div>
                </v-card>
            </v-dialog>

            <download-images-multiple
                    v-if="showDownloadRecruitmentApplications"
                    :recruitments="selectedRecruitments"
                    :shown.sync="showDownloadRecruitmentApplications"
            >
            </download-images-multiple>


        </template>

        <excluded-words-dlg
                :shown.sync="showExcluded"
                v-if="showExcluded"
                @restore="wordRestored"
        ></excluded-words-dlg>
        <recruitment-search @gotoRecruitment="gotoRecruitment" :shown.sync="showSearchAll"></recruitment-search>
    </div>
</template>

<script>
import Loader from "../General/Loader/Loader";
import MultiSelectList from "../General/Multi Select List/MultiSelectList";
import {format, isSameDay, isSameMonth, isSameYear} from "date-fns";
import {arrSplice, dateFormats, exportStats, objectifyArr, validationRules} from "../../core/codeFunctions";
import Divider from "../General/Divider";
import ModifyRecruitmentGroup from "./ModifyRecruitmentGroup";
import ModifyRecruitmentDlg from "./ModifyRecruitmentDlg";
import ExcludedWordsDlg from "@/components/Recruitment/ExcludedWordsDlg";
import DownloadImages from "@/components/Recruitment/DownloadImages";
import {mapGetters} from "vuex";
import randomMC  from 'random-material-color';
import DownloadImagesMultiple from "@/components/Recruitment/DownloadImagesMultiple";
import RecruitmentSearch from "@/components/Recruitment/RecruitmentSearch";

export default {
    components: {
        RecruitmentSearch,
        DownloadImagesMultiple,
        DownloadImages,
        ExcludedWordsDlg, ModifyRecruitmentDlg, ModifyRecruitmentGroup, Divider, MultiSelectList, Loader},
    props: {
        value: Boolean,
    },
    data() {
        return {
          moveFilter: null,
            showSearchAll: false,
            allRecruitments: false,
            refresh: false,
            randomMC,
            validationRules,
            startingUp: false,
            groups: [],
            selectedGroup: null,
            format,
            dateFormats,
            showCreate: false,
            showModifyGroup: false,
            createGroup: {
                description: null,
                cutOff: new Date
            },
            recruitmentDetail: null,
            loadingRecruitmentDetail: false,
            headers: [
                {text: "Contract", value: "contract"},
                {text: "Export", value: "export"},
                {text: "Captured", value: "captured"},
                {text: "Clock No", value: "clockNo"},
                {text: "Surname", value: "surname"},
                {text: "Name", value: "name"},
                {text: "Gender", value: "gender"},
                {text: "Position", value: "position"},
                {text: "IdNo", value: "idNo"},
                {text: "Passport Number", value: "passportNumber"},
                {text: "Nationality", value: "nationality"},
                {text: "Asylum Expiry", value: "asylumExpiry"},
                {text: "DOB", value: "dob"},
                {text: "Address", value: "address"},
                {text: "Next of Kin", value: "nextOfKin"},
                {text: "Next of Kin Cell", value: "nextOfKinCell"},
                {text: "Tax No", value: "taxNo"},
                {text: "Cell No", value: "cellNo"},
                {text: "Size", value: "size"},
                {text: "Bank Name", value: "bankName"},
                {text: "Acc Holder", value: "accHolder"},
                {text: "Branch", value: "branch"},
                {text: "AccNo", value: "accNo"},
            ],
            searchStr: null,
            selectedRecruitment: null,
            showRecruitmentModify: false,
            processedFilter: false,
            showExcluded: false,
            showDownload: false,
            selectedRecruitments: [],
            recruitmentContracts: [],
            showContracts: false,
            showCreateContract: false,
            showModifyContract: null,
            modifyContract: {
                id: null,
                description: null,
                fkContract: null,
                fkRecruitmentGroup: null
            },
            loadingModifyContract: false,
            selectedContract: null,
            showMoveToContract: false,
            loadingMoveToContract: false,
            selectedMoveContract: null,
            showMoveToAnotherRecruitmentGroup: false,
            loadingMoveToAnotherRecruitmentGroup: false,
            selectedMoveToAnotherRecruitmentGroup: null,
            showDownloadRecruitmentApplications: false,
          loadingExclude: false,
            archiveView: false,
          refreshSelectList: false
        }
    },
    watch: {
      refreshSelectList(val) {
        if (val) {
          setTimeout(() => {
            this.refreshSelectList = false
          }, 500)
        }
        
      },
        refresh(val) {
            if (val)
                setTimeout(() => {
                    this.refresh = false
                })
        },
        showMoveToContract(val) {
            if (val) {
                this.selectedMoveContract = null
            }
        },
        showMoveToAnotherRecruitmentGroup(val) {
            if (val) {
                this.selectedMoveToAnotherRecruitmentGroup = null
            }
        },
        showCreateContract(val) {
            if (val) {
                this.modifyContract = {
                    id: null,
                    description: null,
                    fkContract: null,
                    fkRecruitmentGroup: this.selectedGroup.id
                }
            }
        },
        showCreate(val) {
            if (val) {
                this.createGroup.description = null;
                this.createGroup.cutOff = null;
            }
        },
        selectedGroup(val) {
            if (val) {
                this.reloadRecruitmentGroupDetail()
            }
        }
    },
    mounted() {
        this.startup();
    },
    methods: {

      async excelExc(exportRes) {
        try {
          this.loadingExclude = true
          const update = await this.$newReq('POST', `recruitment/excelExclude`, {ids: this.selectedRecruitments.map(obj => obj.id), val: exportRes ? 1 : 0})
          console.log(update)
          this.selectedRecruitments.forEach(rec => {
            rec.export = exportRes ? 1 : 0
          })
        } catch (e) {
          this.$snack.netWorkError();
        } finally {
          this.loadingExclude = false
        }

      },

        async gotoRecruitment({id, fkRecruitmentGroup}) {
            this.showSearchAll = false;
            this.selectedGroup = this.groups.find(group => group.id === fkRecruitmentGroup)
            const vm = this;
            function waitForLoad() {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        if (vm.loadingRecruitmentDetail)
                            resolve(waitForLoad())
                        else
                            resolve(true)
                    }, 250)
                })
            }
            await waitForLoad()
            this.selectedRecruitments = [this.recruitmentDetail.find(recruitment => recruitment.id === id)]
            this.selectedRecruitment = this.selectedRecruitments[0];
            this.showRecruitmentModify = true;
        },

        async moveToRecruitment() {
            try {
                this.loadingMoveToAnotherRecruitmentGroup = true
                const recruitments = await this.$newReq('POST', `recruitment/groups/moveRecruitments`, {
                    recruitment: this.selectedMoveToAnotherRecruitmentGroup,
                    recruitments: this.selectedRecruitments.map(val => val.id)
                })
                this.selectedRecruitments = [];
                if (this.selectedMoveToAnotherRecruitmentGroup !== this.selectedGroup.id) {
                    arrSplice(this.recruitmentDetail, rec => (Array.isArray(recruitments) ? recruitments : [recruitments]).includes(rec.id))
                }
                this.showMoveToAnotherRecruitmentGroup = false
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingMoveToAnotherRecruitmentGroup = false
                this.refresh = true
            }
        },

        async moveToContract() {
            try {
                this.loadingMoveToContract = true
                const recruitments = await this.$newReq('POST', `recruitment/groups/contracts/moveRecruitments`, {
                    contract: this.selectedMoveContract,
                    recruitments: this.selectedRecruitments.map(val => val.id)
                })
                this.recruitmentDetail.forEach(rec => {
                    const updatedRec = recruitments.find(searchRec => searchRec.id === rec.id)
                    if (updatedRec)
                        rec.fkRecruitmentContract = updatedRec.fkRecruitmentContract
                })
                this.showMoveToContract = false
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.loadingMoveToContract = false
                this.refresh = true
            }
        },

        modifyExistingContract(contract) {
            this.modifyContract = contract
            this.showModifyContract = true;
        },

        async validateModifyContract() {
            if (!this.$refs.modifyContractForm.validate()) {
                return this.$snack.error("Missing fields")
            }
            try {
                this.loadingModifyContract = true;
                const modifiedContract = await this.$newReq('POST', `recruitment/groups/contracts/upsert`, this.modifyContract)
                if (this.recruitmentContracts.find(obj => obj.id === modifiedContract.id)) {
                    const contract = this.recruitmentContracts.find(obj => obj.id === modifiedContract.id)
                    Object.assign(contract, modifiedContract)
                } else {
                    this.recruitmentContracts.push(modifiedContract)
                }
                this.showRecruitmentModify = null;
                this.showCreateContract = false;
                this.showModifyContract = false;
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.loadingModifyContract = false;
            }
        },

        wordRestored(obj) {
            try {
                const arr = this.$refs.recruitmentDlg.excludedWords[obj.documentType]
                arrSplice(arr, word => word === obj.string)
            } catch (e) {
                console.log(e)
            }
        },

        excelExport() {

            const headers = [
                {text: "CO NO", value: "clockNo"},
                {text: "DOCS YES OR NO", value: "none"},
                {text: "EXPORT ID", value: "none"},
                {text: "UNIQUE CODE 1", value: "none"},
                {text: "UNIQUE CODE 2", value: "none"},
                {text: "INITIALS", value: "initials"},
                {text: "NAME", value: "name"},
                {text: "SURNAME", value: "surname"},
                {text: "NICKNAME", value: "name"},
                {text: "ID NO", value: "idNo"},
                {text: "PASSPORT NO", value: "passportNumber"},
                {text: "PASSPORT/ASYLUM EXPIRE DATE", value: "asylumExpiry"},
                {text: "CITIZENSHIP", value: "nationality"},
                {text: "BIRTH DATE", value: "dob"},
                {text: "M/F (GENDER)", value: "gender"},
                {text: "JOB DESCRIPTION", value: "position"},
                {text: "TEAM", value: "none"},
                {text: "PPE SIZE(34/M)", value: "size"},
                {text: "START DATE", value: "none"},
                {text: "TERM DATE", value: "none"},
                {text: "TAX NO", value: "taxNo"},
                {text: "CELL NO", value: "cellNo"},
                {text: "BANK NAME", value: "bankName"},
                {text: "BRANCH", value: "branch"},
                {text: "ACCOUNT", value: "accNo"},
                {text: "STREET NAME", value: "address"},
                {text: "STREET NO", value: "none"},
                {text: "SURBURB", value: "none"},
                {text: "CITY", value: "none"},
                {text: "POSTAL CODE", value: "none"},
                {text: "NEXT OF KIN NAME", value: "nextOfKin"},
                {text: "NEXT OF KIN CELL NO", value: "nextOfKinCell"},
            ]


            const exportItems = this.$refs.recruitmentsTable.selectableItems.filter(val => val.export).map(item => {
                return {
                    ...item,
                    initials: `${item.name || ''}`.split(' ').map(word => {
                        const letters = word.split('')
                        if (!word || letters.length)
                            return letters.shift()
                        else
                            return ''
                    }).join('').toUpperCase()
                }
            }).map((item) => {
                let newObj = {}
                for (const key of Object.keys(item)) {
                    try {
                        newObj[key] = item[key].toString().toUpperCase()
                    } catch (e) {
                        newObj[key] = item[key] = null
                    }
                }
                return newObj
            })

            console.log(
                    {exportItems}
            )

            exportStats(
                    `${this.selectedGroup.description} ${format(new Date(), 'yyyy-MM-dd')}`,
                    'Recruitments', headers,
                    exportItems,
            )
        },

        recruitmentUpdated(recruitment) {
            this.recruitmentDetail.splice(this.recruitmentDetail.indexOf(this.selectedRecruitment), 1, recruitment)
            console.log({recruitment})
            this.selectedRecruitment = recruitment
        },

        nextRecruitment() {
            const curRecruitment = this.selectedRecruitment;
            this.selectedRecruitment = null;
            this.$nextTick(() => {
                this.selectedRecruitment = this.$refs.recruitmentsTable.selectableItems[this.$refs.recruitmentsTable.selectableItems.indexOf(curRecruitment) + 1]
            })
        },

        previousRecruitment() {
            const curRecruitment = this.selectedRecruitment;
            this.selectedRecruitment = null;
            this.$nextTick(() => {
                this.selectedRecruitment = this.$refs.recruitmentsTable.selectableItems[this.$refs.recruitmentsTable.selectableItems.indexOf(curRecruitment) - 1]
            })
        },

        modifyRecruitment(recruitment) {
            this.selectedRecruitment = recruitment;
            this.showRecruitmentModify = true
        },
        async reloadRecruitmentGroupDetail() {
            try {
                this.selectedRecruitments = []
                this.loadingRecruitmentDetail = true
                this.recruitmentDetail = null
                const {recruitments, contracts} = await this.$newReq('POST', `recruitment/groups/groupViewStartup`, this.selectedGroup)
                this.recruitmentDetail = recruitments;
                this.recruitmentContracts = (contracts || []);
                this.showContracts = true
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.loadingRecruitmentDetail = false
            }
        },
        async startup() {
            try {
                this.startingUp = true
                const {groups} = await this.$newReq('GET', `recruitment/groups`);
                this.groups = groups.map(obj => {
                    return {
                        ...obj,
                        created: new Date(obj.created),
                        cutOff: new Date(obj.cutOff),
                    }
                });
            } catch (e) {
                this.$snack.netWorkError();
            } finally {
                this.startingUp = false
            }
        },
        groupChanged(newGroup, group) {
            this.showModifyGroup = false;
            this.showCreate = false;

            try {
                group.cutOff = new Date(group.cutOff)
                group.created = new Date(group.created)
                
            } catch (e) {
                console.log(e)
            }

            if (newGroup)
                this.groups.push(group)
            else
              for (const v of this.groups) {
                  if (v.id === group.id) {
                    Object.assign(v, group)
                  }
              }

            this.selectedGroup = group
          
          // this.refreshSelectList = true
        },
    },
    computed: {
        ...mapGetters(["hrPinsRef", "usersRef", "contracts", "contractsRef", "user"]),

        moveGroups() {
           const items = this.moveFilter ? this.groups.filter(v => (v.description || '').toLowerCase().includes(this.moveFilter.toLowerCase())) : this.groups
          return items.sort((a, b) => a.description.localeCompare(b.description))
        },
      
        archivedGroupFilter() {
          return this.groups.filter(group => this.archiveView === !!group.archived)
        },
      
        recruitmentGroupContractsRef() {
            return this.recruitmentContracts ? objectifyArr((this.recruitmentContracts || []), 'id') : null
        },

        selectedRecruitmentInfo() {
            if (this.selectedRecruitment) {



                const info = {
                    capturedBy: null,
                    capturedStr: null,
                    createdStr: null,
                    lastUpdatedBy: null,
                    updatedStr: null,
                }
                info.capturedBy = this.hrPinsRef[this.selectedRecruitment.fkCapturedBy] ? this.hrPinsRef[this.selectedRecruitment.fkCapturedBy].name : "None"
                info.lastUpdatedBy = this.usersRef[this.selectedRecruitment.fkLastUpdatedBy] ? this.usersRef[this.selectedRecruitment.fkLastUpdatedBy].name : "None"
                try {
                    info.capturedStr = format(new Date(this.selectedRecruitment.captured), "yyyy-MM-dd HH:mm:ss")
                } catch (e) {
                    console.log(e)
                }
                try {
                    info.createdStr = format(new Date(this.selectedRecruitment.created), "yyyy-MM-dd HH:mm:ss")
                } catch (e) {
                    console.log(e)
                }
                try {
                    if (this.selectedRecruitment.updated)
                        info.updatedStr = format(new Date(this.selectedRecruitment.updated), "yyyy-MM-dd HH:mm:ss")
                } catch (e) {
                    console.log(e)
                }

                return info

            } else {
                return {
                    capturedBy: "None",
                    capturedStr: "None",
                    createdStr: "None",
                    lastUpdatedBy: "None",
                    updatedStr: "None",
                }
            }
        },

        contractGroupFilter() {
            return this.selectedContract
                    ? (this.recruitmentDetail || []).filter(item => item.fkRecruitmentContract === this.selectedContract.id)
                    : (this.recruitmentDetail || [])
        },

        filteredDetail() {
            return this.processedFilter
                    ? (this.contractGroupFilter || []).filter(item => !(!!item.name && (!!item.idNo || !!item.passportNo)))
                    : (this.contractGroupFilter || [])
        },
        sortedContracts() {
            return [...(this.recruitmentContracts || [])].sort((a, b) => a.description > b.description ? 1 : -1)
        }
    }
}
</script>

<style scoped>

</style>